export default __webpack_public_path__ + "static/media/loginImage.ccbebb35.svg";